import { useForm } from "react-hook-form"
import { useNewOrderFunnel } from "../utils/useNewOrderFunnel"
import { OffersSummary } from "../OffersSummary"
import { SignupForm } from "../Forms/SignupForm"
import { OrderOnlineLink } from "../OrderOnlineLink"

type TSignUpFormValues = {
  email: string
  primary_phone: string
  first_name: string
  last_name: string
  business_name?: string
  business_title?: string
  business_attention_line?: string
  service_address_id?: number
  mailing_address_id?: number
  revenue_class?: string
  electric_choice_id?: string
  account_number?: string
  offer_code?: string
  verification_method?: string
  marketing_opt_in: boolean
}

export const SignUp = () => {
  const {
    prospect,
    shopper,
    selectedOffer,
    setStep,
    selectedAddress,
    selectedRevenueClassCode,
  } = useNewOrderFunnel()

  const form = useForm<TSignUpFormValues>({
    mode: "onTouched",
    defaultValues: {
      email:
        typeof prospect?.email === "string"
          ? prospect.email
          : prospect?.email?.email_address || "",
      primary_phone: prospect?.primary_phone || "",
      first_name: prospect?.first_name || "",
      last_name: prospect?.last_name || "",
      business_name: "",
      business_title: "",
      business_attention_line: "",
      service_address_id: selectedAddress?.address_id,
      mailing_address_id: selectedAddress?.address_id,
      revenue_class: selectedRevenueClassCode,
      electric_choice_id: "",
      account_number: "",
      offer_code: selectedOffer?.offer_code,
      verification_method: "",
      marketing_opt_in: true,
    },
  })

  if (!selectedOffer) {
    return (
      <div className="tw-text-sm">
        No offer selected. Return to Choose Offer.
      </div>
    )
  }

  // Keep offer_code synced if selection changes externally
  if (
    selectedOffer &&
    form.getValues("offer_code") !== selectedOffer.offer_code
  ) {
    form.setValue("offer_code", selectedOffer.offer_code, {
      shouldDirty: false,
    })
  }

  return (
    <div className="tw:flex tw:flex-col tw:gap-6">
      <div className="tw:flex tw:flex-col tw:gap-2">
        <OffersSummary
          data={[selectedOffer]}
          title="Selected Offer"
          includeEnroll={false}
        />
        {shopper?.short_key && (
          <OrderOnlineLink shopper_short_key={shopper.short_key} />
        )}
      </div>

      <SignupForm
        prospect={prospect}
        selectedOffer={selectedOffer}
        selectedAddress={selectedAddress}
        revenueClassCode={selectedRevenueClassCode}
        onNext={() => setStep("verification")}
        onCancel={() => setStep("chooseOffer")}
      />
    </div>
  )
}
